import React from 'react';

import DateField from 'components/formInputs/DateField';
import RadioGroupField from 'components/formInputs/RadioGroupField';
import SelectField from 'components/formInputs/SelectField';
import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import ShowHide from 'components/ShowHide';

import { LABELS, NUM_MEDICATIONS, SEVERITIES } from './constants';
import { DepressionFormProps } from './types';

const DepressionForm: React.FC<DepressionFormProps> = ({
  handleSubmit,
  invalid,
  submitting,
  values,
}) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <DateField label={LABELS.diagnosedAt} name="diagnosedAt" />
    <RadioGroupField groupLabel={LABELS.severity} name="severity" options={SEVERITIES} />
    <ToggleField groupLabel={LABELS.currentlyTreated} name="currentlyTreated" />
    <ShowHide visible={values.currentlyTreated === false}>
      <ToggleField groupLabel={LABELS.everTreated} name="everTreated" />
      <ShowHide visible={values.everTreated}>
        <DateField label={LABELS.treatmentEndDate} name="treatmentEndDate" />
      </ShowHide>
    </ShowHide>
    <ShowHide visible={values.currentlyTreated}>
      <SelectField
        label={LABELS.numberOfMedications}
        name="numberOfMedications"
        options={NUM_MEDICATIONS}
      />
      <ToggleField groupLabel={LABELS.psychotherapy} name="psychotherapy" />
    </ShowHide>
    <ToggleField groupLabel={LABELS.hospitalized} name="hospitalized" />
    <ShowHide visible={values.hospitalized}>
      <DateField label={LABELS.hospitalizedAt} name="hospitalizedAt" />
    </ShowHide>
  </FormWrapper>
);

export default DepressionForm;
